"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldLevelError = exports.noErrors = void 0;
exports.noErrors = {
    status: "",
    message: null,
    errors: [],
    fieldErrors: {}
};
exports.fieldLevelError = {
    status: "CONFLICT",
    message: null,
    errors: [],
    fieldErrors: {
        name: ["Name is required"]
    }
};
//# sourceMappingURL=form-errors.js.map